import axiosInstance from './axiosInstance';

const getDetailsServicesConfigRate = (nameService) =>
  axiosInstance.get(`/internal/admin/config/rates/${nameService}`);

export default getDetailsServicesConfigRate;
